<template>
  <div class="fileupload">
    <uploader
      :options="options"
      :autoStart="false"
      ref="uploader"
      :file-status-text="statusText"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      class="uploader-example"
      v-if="!submitted">
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop v-if="!disabledFalg">
        <p>{{language=='cn'?'拖拽文件至此或点击按钮':'Drag and drop the file here or click the button'}}</p>
        <p style="color: red">{{ msg }}</p>
        <uploader-btn>{{language=='cn'?'选择文件':'Select File'}}</uploader-btn>
      </uploader-drop>
      <div>
        <uploader-list></uploader-list>
      </div>
    </uploader>
    <el-row :gutter="10">
      <el-col :span="12">
        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <i class="el-icon-folder-checked"></i>
            <span>{{language=='cn'?'已上传列表':'Uploaded list'}}</span>
          </div>
          <div class="text item" v-for="(item,index) in completeArray" :key="index">
            <div>
              <el-row>
                <el-col :span="8">
                  <img
                    :src="item.path"
                    v-if="attrs[0].indexOf(item.type)!=-1"
                    style="width: 100px;height: 50px"
                  />
                  <i
                    class="el-icon-document"
                    v-if="attrs[0].indexOf(item.type)==-1"
                    style="font-size: 50px"
                  ></i>
                </el-col>
                <el-col :span="12">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fileName"
                    placement="top-start"
                    v-if="item.fileName.replace(item.businessCode+'-','').length>20"
                  >
                    <span>{{ item.fileName.replace(item.businessCode + '-', '').slice(0, 15) }}......{{ item.fileName.split('.')[item.fileName.split('.').length - 1] }}</span>
                  </el-tooltip>
                  <span
                    v-if="item.fileName.replace(item.businessCode+'-','').length<=20"
                  >{{ item.fileName.replace(item.businessCode + '-', '') }}</span>
                </el-col>
                <el-col :span="2">
                  <i class="el-icon-download" style="cursor: pointer" @click="download(item.path)"></i>
                </el-col>
                <el-col :span="2" v-if="!submitted">

                  <el-popconfirm v-if="!disabledFalg" @onConfirm="deleteFile(item.businessCode,item.fileName,1)"
                                 :confirmButtonText='language=="cn"?"确定":"confirm"'
                                 :cancelButtonText='language=="cn"?"取消":"cancel"'
                    :title="language=='cn'?'您确定删除此文件吗？':'Are you sure to delete this file?'">
                    <i
                      slot="reference"
                      class="el-icon-delete"
                      style="cursor: pointer"
                    ></i>
                  </el-popconfirm>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card" style="margin-top: 10px">
          <div slot="header" class="clearfix">
            <i class="el-icon-files"></i>
            <span>{{language=='cn'?'未完成上传列表':'Incomplete upload list'}}</span>
          </div>
          <div class="text item" v-for="(item,index) in unCompleteArray" :key="index">
            <div>
              <el-row>
                <el-col :span="10">
                  <i class="el-icon-document" style="font-size: 50px"></i>
                </el-col>
                <el-col :span="12">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.fileName"
                    placement="top-start"
                    v-if="item.fileName.length>20"
                  >
                    <span>{{ item.fileName.slice(0, 15) }}...{{ item.fileName.split('.')[item.fileName.split('.').length - 1] }}({{language=='cn'?'已上传':'have already uploaded'}}{{ item.schedule * 100 }}%)</span>
                  </el-tooltip>
                  <span
                    v-if="item.fileName.replace(item.hash+'-','').length<=20"
                  >{{ item.fileName }}({{language=='cn'?'已上传':'have already uploaded'}}{{ Math.floor(item.schedule * 10000/100) }}%)</span>
                </el-col>
                <el-col :span="2" v-if="!disabledFalg">
                  <i
                    class="el-icon-delete"
                    style="cursor: pointer"
                    @click="deleteFile(item.hash,item.fileName,2)"
                  ></i>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import {getFileList, deleteFiles} from '../api/system/file'
import {getToken} from '../utils/auth'

export default {
  name: 'fileComponent',
  props: [
    'verifyTypeArray',
    'maxSize',
    'msg',
    'remark',
    'uploadType',
    'submitted',
    'maxUploadNum',
    'labelField',
    'language',
    'disabledFalg'
  ],
  // verifyTypeArray（可选）：需要过滤的文件类型，即此文件类型的文件不上传，
  // maxSize：文件最大上传大小,
  // uploadType 上传的文件类型
  // msg:提示信息
  // remark:文件标识
  // uploadType 需要上传的文件类型
  // maxUploadNum 最大上传的文件数量
  // labelField 表单字段
  // language 中英切换
  data () {
    return {
      remarkCopy: '',
      stopOrStartFalg: true,
      currentUploadMd5: [],
      options: {
        allowDuplicateUploads: true, // 如果说一个文件以及上传过了是否还允许再次上传,默认值为 false,不配置的情况下被remove的文件不能二次上传，故开启
        target: this.uploadUrl,
        chunkSize: 5 * 1024 * 1024, // 上传文件分块大小
        fileParameterName: 'file', // 上传文件时文件的参数名，默认file
        simultaneousUploads: 5, // 并发上传数量，默认3
        maxChunkRetries: 3, // 最大自动失败重试上传次数
        testChunks: true, // 是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        checkChunkUploadedByResponse: function (chunk, message) {
          if (message) {
            let objMessage = JSON.parse(message)
            return (
              (objMessage.uploadedChunks || []).indexOf(chunk.offset + 1) >= 0
            )
          } else {
            // 没有返回json数据表示没有发送上传分片的请求，该文件已经上传过了，不予上传
            return true
          }
        },
        headers: {
          Authorization: 'Bearer ' + getToken()
        }
      },
      attrs: [
        ['.png', '.jpg', '.jpeg', '.gif', '.bmp'],
        ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv'],
        [
          '.doc',
          '.docx',
          '.xls',
          '.xlsx',
          '.ppt',
          '.pptx',
          '.pdf',
          '.txt',
          '.tif',
          '.tiff'
        ]
      ],
      autoStart: false,
      statusText: {
        success: this.language === 'cn' ? '成功了' : 'successfully',
        error: this.language === 'cn' ? '出错了' : 'error',
        uploading: this.language === 'cn' ? '上传中' : 'uploading',
        paused: this.language === 'cn' ? '暂停中' : 'break',
        waiting: this.language === 'cn' ? '等待中' : 'waiting'
      },
      uploadState: '',
      completeArray: [],
      unCompleteArray: [],
      localFileArry: [],
      hashMap: [],
      uploadNum: 0
    }
  },
  computed: {
    // Uploader实例
    uploader () {
      return this.$refs.uploader.uploader
    }
  },
  created () {
    this.remarkCopy = this.remark
    if (!this.remarkCopy) {
      this.remarkCopy = this.labelField + Math.random()
    }
    this.options.target = this.options.target + this.remarkCopy
  },
  mounted () {
    if (this.remarkCopy) {
      this.getFileList()
    }
  },
  destroyed () {

  },
  watch: {
    'uploadNum' (val) {
      if (this.uploadNum <= this.maxUploadNum) {
        this.$emit('onFileSuccess', true, this.remarkCopy, this.labelField)
      } else {
        this.$emit('onFileSuccess', false, this.remarkCopy, this.labelField)
      }
    }
  },
  methods: {
    deleteFile (md5, fileName, type) {
      this.uploadNum--
      this.hashMap[md5] = undefined
      this.uploader.fileList.forEach(f => {
        if (f.name === fileName) {
          this.uploader.removeFile(f)
        }
      })
      deleteFiles(this.systemURL, [
        {
          hash: md5,
          remark: this.remarkCopy,
          fileName: fileName
        }
      ]).then(res => {
        this.$message.success(this.language === 'cn' ? '删除成功' : 'successfully delete')
      })
      if (type === 1) {
        for (let i = 0; i < this.completeArray.length; i++) {
          if (this.completeArray[i].businessCode === md5) {
            this.completeArray.splice(i, 1)
            break
          }
        }
      } else {
        for (let i = 0; i < this.unCompleteArray.length; i++) {
          if (this.unCompleteArray[i].businessCode === md5) {
            this.unCompleteArray.splice(i, 1)
            break
          }
        }
      }
    },
    download (path) {
      window.open(path)
    },
    // 文件上传成功回调
    onFileSuccess (rootFile, file, response, chunk) {
      this.uploadNum++
      this.uploadState = this.language === 'cn' ? '上传成功' : 'successfully upload'
      this.currentUploadMd5.push(chunk.file.uniqueIdentifier)
      this.getOneFileList(chunk.file.uniqueIdentifier)
    },
    getOneFileList (md5) {
      getFileList(this.systemURL, this.remarkCopy).then(res => {
        this.completeArray = []
        if (
          res.data.completeArray.length > 0 ||
          res.data.unCompleteArray.length > 0
        ) {
          let index = this.currentUploadMd5.indexOf(md5)
          if (index !== -1) {
            this.currentUploadMd5.splice(index, 1)
          }
        }
        res.data.completeArray.forEach(item => {
          this.completeArray.push(item)
        })
        res.data.unCompleteArray.forEach(item => {
          this.unCompleteArray.push(item)
        })
      })
    },
    getFileList () {
      getFileList(this.systemURL, this.remarkCopy).then(res => {
        this.unCompleteArray = res.data.unCompleteArray
        this.completeArray = res.data.completeArray
        this.uploadNum = this.completeArray.length
        if (this.uploadNum === 0) {
          this.$emit('onFileSuccess', true, this.remarkCopy, this.labelField)
        }
      })
    },
    // 添加文件时的校验
    onFileAdded (file) {
      let falg = true
      let tempAry = []
      if (this.uploadType) {
        this.uploadType.forEach(item => {
          tempAry.push(item.toLowerCase())
        })
      }
      let that = this
      // 移除超过上传大小的文件
      if (file.size > that.maxSize) {
        this.uploader.removeFile(file)
        falg = false
      }
      if (tempAry.length > 0) {
        if (tempAry.indexOf(file.name.split('.').pop().toLowerCase()) === -1) {
          // 不是指定的类型移除
          that.uploader.removeFile(file)
          falg = false
        }
      }
      if (that.verifyTypeArray) {
        that.verifyTypeArray.forEach(item => {
          if (item.toLowerCase() === file.getType().toLowerCase()) {
            // 移除不符合指定文件类型的文件
            that.uploader.removeFile(file)
            falg = false
            return false
          }
        })
      }
      if (falg) {
        if ((that.uploadNum + that.uploader.fileList.length) > that.maxUploadNum) {
          that.uploader.removeFile(file)
          that.$notify({
            title: that.language === 'cn' ? '最多上传' : 'Up to upload ' + that.maxUploadNum + that.language === 'cn' ? '个文件，超出上传文件限制的数量' : 'file,the number of files exceeding the upload limit',
            type: 'warning'
          })
        } else {
          that.computeMD5(file, this.uploader.fileList.length)
        }
      } else {
        that.$notify({
          title: that.language === 'cn' ? '文件类型不符或者超出上传大小限制' : 'File type is inconsistent or exceeds upload size limit',
          type: 'warning'
        })
      }
    },
    /**
     * 计算md5，实现断点续传及秒传
     * @param file
     */
    computeMD5 (file, length) {
      let fileReader = new FileReader()
      let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice
      let currentChunk = 0
      const chunkSize = this.options.chunkSize
      let chunks = Math.ceil(file.size / chunkSize)
      let spark = new SparkMD5.ArrayBuffer()
      // 文件状态设为"计算MD5"
      // this.statusText.paused = '计算MD5中'
      this.uploadState = this.language === 'cn' ? '计算MD5中' : 'The calculated MD5'
      // 上传文件暂停
      file.pause()
      loadNext()
      fileReader.onload = e => {
        spark.append(e.target.result)
        if (currentChunk < chunks) {
          currentChunk++
          loadNext()
          // 实时展示MD5的计算进度
          this.$nextTick(() => {
            this.uploadState =
              this.language === 'cn' ? '校验MD5' : 'Checkout MD5' + ((currentChunk / chunks) * 100).toFixed(0) + '%'
          })
        } else {
          let md5 = spark.end()
          this.uploadState = this.language === 'cn' ? 'MD5计算完毕' : 'Is evaluated MD5'
          let hashStrAry = []
          this.completeArray.forEach(hash => {
            hashStrAry.push(hash.businessCode)
          })
          let falg = true
          if (hashStrAry.indexOf(md5) !== -1) {
            this.$notify({
              title: this.language === 'cn' ? '文件不能重复上传' : 'Files cannot be uploaded repeatedly',
              type: 'error'
            })
            this.uploader.removeFile(file)
            falg = false
          }
          if (this.hashMap[md5]) {
            this.$notify({
              title: this.language === 'cn' ? '文件不能重复上传' : 'Files cannot be uploaded repeatedly',
              type: 'error'
            })
            this.uploader.removeFile(file)
            falg = false
          } else {
            this.hashMap[md5] = {
              hash: md5,
              remark: this.remark,
              fileName: file.name
            }
          }
          if (falg) {
            this.computeMD5Success(md5, file)
          }
          // this.statusText.paused = '暂停中'
          /*
                          console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
              */
        }
      }
      fileReader.onerror = function () {
        this.error(this.language === 'cn' ? `文件${file.name}读取出错，请检查该文件` : `${file.name} Error reading file, please check the file`)
        file.cancel()
      }

      function loadNext () {
        let start = currentChunk * chunkSize
        let end =
          start + chunkSize >= file.size ? file.size : start + chunkSize
        fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end))
      }
    },
    computeMD5Success (md5, file) {
      // 将自定义参数直接加载uploader实例的opts上
      // Object.assign(this.uploader.opts, {
      //   query: {
      //     ...this.params
      //   }
      // })
      file.uniqueIdentifier = md5
      // 继续上传文件
      file.resume()
      // 移除未上传完成列表
      for (let i = 0; i < this.unCompleteArray.length; i++) {
        if (this.unCompleteArray[i].hash === file.uniqueIdentifier) {
          this.unCompleteArray.splice(i, 1)
          break
        }
      }
    }
  }
}
</script>

<style scoped>
.el-col-12 {
  width: 49.5%;
}
</style>



// WEBPACK FOOTER //
// src/components/fileComponent.vue